export const flowStatusAppearance = {
  RUNNING: "inprogress",
  FINISHED: "success",
  FAILED: "removed",
  TIMED_OUT: "removed",
  CANCELLED: "moved",
  PAUSED: "moved",
};

export const getStatusAppearance = (status) => flowStatusAppearance[status] || "default";

export const formatRunTimestamp = (timestamp) => {
  if (!timestamp) {
    return "-";
  }

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return timestamp;
  }

  return date.toLocaleString();
};
